export default __webpack_public_path__ + "static/media/include_5_male@2x.9c89a5c5.jpg";